var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDotNet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 26,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M9.315 10.182c.967 2.956 1.333 8.23 4.16 8.23.215 0 .432-.022.65-.063-2.569-.6-2.874-5.815-4.441-8.516-.125.114-.248.23-.369.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M9.684 9.833c1.568 2.7 1.872 7.917 4.441 8.516.202-.037.405-.093.607-.164-2.306-1.13-2.943-6.195-4.724-8.633-.11.091-.218.185-.324.281"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14559A",
    d: "M11.943 8.227c-.215 0-.433.02-.652.062-.572.108-1.153.354-1.738.727.16.158.312.338.455.536.596-.495 1.188-.86 1.777-1.08.216-.08.437-.142.663-.184a2.043 2.043 0 0 0-.505-.061Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M16.533 17.143c.245-.197.482-.404.709-.622-.982-2.942-1.334-8.29-4.18-8.29a3.37 3.37 0 0 0-.614.056c2.593.645 2.925 6.286 4.085 8.856"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3092C4",
    d: "M12.448 8.288a2.044 2.044 0 0 0-.505-.061l1.119.004c-.204 0-.409.019-.614.057Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1969BC",
    d: "M16.483 17.768a4.22 4.22 0 0 1-.321-.347 5.886 5.886 0 0 1-1.43.763 2.204 2.204 0 0 0 .988.227c.531 0 .952-.063 1.31-.235a2.488 2.488 0 0 1-.547-.408Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M11.785 8.473c2.322 1.215 2.524 6.715 4.377 8.949.126-.09.25-.182.37-.279-1.16-2.57-1.491-8.21-4.084-8.855a4.013 4.013 0 0 0-.663.185Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M10.008 9.552c1.78 2.438 2.418 7.502 4.724 8.632a5.881 5.881 0 0 0 1.43-.763c-1.853-2.233-2.055-7.734-4.377-8.948-.59.219-1.181.584-1.777 1.078"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M8.176 10.11c-.279.632-.564 1.461-.909 2.544.686-.966 1.369-1.798 2.048-2.472a7.41 7.41 0 0 0-.302-.79 10.21 10.21 0 0 0-.837.719"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B74B1",
    d: "M9.26 9.21c-.083.06-.165.121-.247.183.108.236.208.502.302.79.12-.12.244-.236.368-.35a4.894 4.894 0 0 0-.423-.622Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#125A9E",
    d: "M9.553 9.016a8.048 8.048 0 0 0-.293.195c.152.187.292.396.424.622a9.9 9.9 0 0 1 .324-.282 4.301 4.301 0 0 0-.455-.535"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M25.393 8.001c-1.314 5.065-4.057 9.133-6.357 10.16h-.004a3.732 3.732 0 0 1-.124.052c-.006.004-.011.004-.016.006l-.035.014-.016.006-.057.02-.024.009a.279.279 0 0 1-.029.01l-.027.009-.025.008-.049.015c-.007 0-.013.004-.02.006-.01.003-.023.005-.034.009l-.022.006a.767.767 0 0 1-.036.009l-.044.01a.935.935 0 0 0 .329.057c2.18 0 4.38-3.908 8.018-10.407h-1.429v.001Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "m6.794 8.432.004-.003c.001 0 .004 0 .005-.003h.003l.035-.014c.003 0 .005 0 .007-.003.003 0 .006-.004.009-.004l.038-.014h.002c.029-.008.056-.02.084-.03l.012-.002.036-.011c.006-.004.011-.004.016-.005l.036-.011c.006 0 .01-.004.014-.004l.12-.03c.006 0 .01-.004.017-.005a.232.232 0 0 1 .035-.007c.005-.003.01-.003.017-.005.011-.003.023-.004.035-.006h.008L7.4 8.26h.015l.034-.006c.006 0 .012-.003.019-.003.01 0 .021-.004.032-.005.006 0 .011 0 .018-.003.025-.004.051-.005.078-.007a2.423 2.423 0 0 0-.232-.012c-2.456 0-5.84 4.557-7.364 10.458h.294c.488-.87.926-1.693 1.327-2.465 1.067-4.18 3.241-7.031 5.173-7.786"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0D82CA",
    d: "M8.176 10.111c.266-.254.545-.494.837-.718a3.952 3.952 0 0 0-.2-.385c-.224.272-.43.632-.637 1.103ZM8.378 8.466c.16.135.304.32.435.541.042-.05.084-.097.127-.141a2.463 2.463 0 0 0-.562-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M1.62 16.218c2.24-4.316 3.3-7.047 5.174-7.786-1.931.755-4.106 3.606-5.174 7.786"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#127BCA",
    d: "M8.94 8.865a2.15 2.15 0 0 0-.127.142c.074.125.14.253.2.385.081-.062.164-.122.247-.182a3.363 3.363 0 0 0-.32-.345Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M2.637 18.664c-.014.003-.028.003-.04.005h-.008c-.012 0-.024.003-.035.003H2.55c-.029.003-.056.003-.083.006h-.008c2.266-.064 3.302-1.199 3.816-2.845.391-1.247.712-2.299.993-3.18-.95 1.336-1.903 2.928-2.862 4.713-.462.86-1.165 1.22-1.768 1.296"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M2.637 18.663c.603-.076 1.306-.435 1.768-1.296.96-1.784 1.913-3.377 2.862-4.714.345-1.083.63-1.912.91-2.543-1.891 1.8-3.79 4.792-5.54 8.552"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#05A1E6",
    d: "M1.62 16.218c-.4.772-.839 1.595-1.326 2.465h.854c.108-.83.266-1.653.472-2.465"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M7.518 8.246c-.007 0-.013.003-.019.003-.01.004-.02.004-.032.005-.006 0-.012 0-.019.003-.011.004-.022.004-.033.006-.005 0-.01 0-.015.003-.024.005-.049.01-.073.013H7.32a.277.277 0 0 1-.035.007c-.006.004-.012.004-.018.005l-.035.007c-.006.003-.01.003-.016.004l-.12.03c-.004 0-.008.004-.014.005a1.952 1.952 0 0 0-.036.01c-.005.004-.011.004-.016.005a.996.996 0 0 0-.036.011c-.005 0-.009.003-.013.003-.028.01-.055.021-.083.03-.012.003-.025.008-.038.013-.005.003-.01.004-.016.006l-.035.013c-.005.004-.01.004-.012.006-1.873.74-2.934 3.47-5.173 7.786a20.788 20.788 0 0 0-.473 2.465h.12c.338 0 .433-.003.822-.003h.376c.027-.004.055-.004.083-.006h.005c.012 0 .023-.003.034-.003H2.6c.012 0 .026-.004.04-.005 1.751-3.76 3.649-6.753 5.54-8.552.207-.471.412-.83.636-1.103a2.09 2.09 0 0 0-.435-.542s-.004 0-.004-.003l-.027-.013-.027-.013a.288.288 0 0 1-.025-.013c-.012-.003-.02-.008-.03-.013l-.024-.01a1.023 1.023 0 0 1-.05-.02l-.021-.009a.697.697 0 0 1-.037-.014c-.006-.004-.013-.005-.02-.007l-.051-.018h-.005L8 8.321c-.004-.003-.008-.003-.013-.004l-.05-.014c-.004 0-.008-.003-.011-.003a1.77 1.77 0 0 0-.125-.028c-.004 0-.008-.003-.013-.003a.738.738 0 0 0-.054-.009c-.004-.003-.007-.003-.01-.003a1.446 1.446 0 0 0-.064-.008h-.012c-.017-.004-.033-.004-.049-.006-.027.004-.053.005-.078.007"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M20.262 10.805c-.43 1.38-.78 2.52-1.083 3.456 1.182-1.627 2.347-3.673 3.456-6.035-1.294.406-1.984 1.336-2.373 2.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M19.216 18.074c-.06.03-.12.06-.18.086 2.3-1.026 5.043-5.094 6.357-10.159h-.267c-3.017 5.39-3.988 8.999-5.91 10.073Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#079AE1",
    d: "M17.715 17.62c.5-.61.908-1.648 1.464-3.36-.642.883-1.288 1.64-1.934 2.258 0 .004 0 .004-.004.006.141.423.296.796.472 1.097"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1969BC",
    d: "M17.715 17.621a2.05 2.05 0 0 1-.685.555 1.938 1.938 0 0 0 .816.232h.007c.018 0 .036 0 .055.003h.188c.006 0 .014 0 .02-.004.014 0 .028 0 .042-.003h.02c.014 0 .03-.003.045-.005h.004l.013-.003c.016-.004.033-.005.048-.008h.014l.054-.009h.009c.036-.006.072-.013.107-.022-.297-.109-.545-.365-.759-.73"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E5CB3",
    d: "M13.475 18.411c.215 0 .432-.021.65-.063.202-.037.405-.093.607-.163a2.21 2.21 0 0 0 .988.226h-2.245Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E5CB3",
    d: "M15.72 18.41c.531 0 .952-.063 1.31-.234a1.939 1.939 0 0 0 .816.231h.007a.3.3 0 0 1 .055.004h.065-2.255.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D60B5",
    d: "M17.974 18.41h.123c.007 0 .014 0 .021-.003.014 0 .028 0 .042-.003h.02c.015 0 .03-.004.045-.005h.004l.013-.003c.016-.004.032-.005.048-.008.005 0 .01 0 .015-.003.017-.004.036-.005.054-.009h.008c.037-.007.072-.014.108-.023a.937.937 0 0 0 .329.058l-.83.004v-.004Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#175FAB",
    d: "M17.242 16.524v-.004c-.226.218-.463.426-.709.622a8.08 8.08 0 0 1-.37.278c.104.124.21.24.32.347.17.164.35.302.548.409a2.045 2.045 0 0 0 .685-.555 5.903 5.903 0 0 1-.473-1.097"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M24.284 8.001h-1.34l-.212.01-.099.212c-1.109 2.362-2.273 4.408-3.456 6.035-.556 1.711-.964 2.75-1.464 3.36.214.365.463.622.759.73.008-.003.015-.003.023-.005h.005c.005 0 .01-.003.016-.003l.037-.01.022-.006.034-.008c.006-.004.013-.005.02-.006l.05-.015a.148.148 0 0 1 .024-.008l.028-.01c.01-.004.02-.006.028-.01l.023-.008.058-.02c.005 0 .01-.005.016-.006l.035-.014c.005-.003.01-.004.016-.006.04-.016.082-.034.124-.053h.004c.06-.027.12-.055.18-.086 1.922-1.074 2.893-4.682 5.91-10.073h-.842Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7DCBEC",
    d: "M7.596 8.238c.005 0 .01 0 .014.004a.11.11 0 0 1 .035.003h.011l.064.009a1.274 1.274 0 0 0 .065.012c.004 0 .009.004.013.004.042.008.084.016.125.027.003 0 .007.004.01.004.018.004.034.009.05.014.006 0 .01.003.015.004.02.005.039.01.059.017 0 0 .002 0 .004.003l.052.018c.007.003.013.005.02.006.012.006.025.01.037.015.007 0 .014.005.02.008l.05.02c.009.004.016.008.024.01a1.35 1.35 0 0 0 .056.025l.027.014c.214.106.41.246.593.416.066-.069.136-.133.21-.191a2.316 2.316 0 0 0-1.554-.437"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5EC5ED",
    d: "M8.94 8.866c.115.107.222.223.32.345.096-.067.194-.132.293-.195a3.085 3.085 0 0 0-.403-.341 1.884 1.884 0 0 0-.21.19"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M7.596 8.238a2.32 2.32 0 0 1 1.554.437c.421-.332.93-.448 1.637-.448H7.364c.079 0 .156.004.232.011Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M10.787 8.226c-.707 0-1.216.116-1.637.449.144.102.278.216.402.34.587-.372 1.167-.619 1.74-.727.214-.04.432-.061.65-.062h-1.155Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M19.179 14.261c.304-.937.652-2.075 1.084-3.456.389-1.244 1.078-2.174 2.371-2.58l.1-.211c-2.109.126-3.095 1.199-3.59 2.787-.868 2.774-1.393 4.572-1.9 5.717.647-.618 1.293-1.376 1.935-2.257Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M22.273 17.672h-.24v.743h-.097v-.742h-.24v-.089h.577v.088Zm.978.743h-.097v-.558c0-.044.003-.098.008-.161a.572.572 0 0 1-.026.08l-.283.64h-.047l-.284-.634a.447.447 0 0 1-.026-.086h-.003c.003.033.005.087.005.162v.557h-.094v-.831h.129l.255.58c.02.044.031.077.037.1h.004l.04-.103.26-.577h.123v.831Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 242.943,
    x2: 242.943,
    y1: 562.152,
    y2: -449.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05A1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05A1E6",
    stopOpacity: 0.549
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 249.812,
    x2: 249.812,
    y1: -157.581,
    y2: 1121.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0994DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#66CEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#127BCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#127BCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 252.137,
    x2: 252.137,
    y1: 996.78,
    y2: -47.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C63B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#33BDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33BDF2",
    stopOpacity: 0.42
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 249.153,
    x2: 249.153,
    y1: -169.95,
    y2: 1192.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#166AB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#36AEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#0798DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0798DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 317.712,
    x2: 317.712,
    y1: -181.111,
    y2: 1267.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#1487CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#165197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#165197"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 7.267,
    x2: 9.315,
    y1: 172.456,
    y2: 172.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33BDF2",
    stopOpacity: 0.698
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DACD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 435.913,
    x2: 435.913,
    y1: 993.451,
    y2: -23.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#136AB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#59CAF5",
    stopOpacity: 0.549
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59CAF5",
    stopOpacity: 0.235
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: -0.008,
    x2: 759.599,
    y1: 531.144,
    y2: 531.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05A1E6",
    stopOpacity: 0.247
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05A1E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 260.277,
    x2: 260.277,
    y1: 976.343,
    y2: -64.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#318ED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38A7E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 262.123,
    x2: 262.123,
    y1: -162.127,
    y2: 1149.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E76BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#36AEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#00ADEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ADEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 279.598,
    x2: 279.598,
    y1: 865.484,
    y2: 10.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1959A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#05A1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#7EC5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EC5EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 459.557,
    x2: 169.637,
    y1: 995.716,
    y2: 109.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#165096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D82CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 191.956,
    x2: 191.956,
    y1: 472.951,
    y2: -11.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05A1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#0495D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0495D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 433.887,
    x2: -17.786,
    y1: -34.271,
    y2: 968.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38A7E4",
    stopOpacity: 0.329
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.962,
    stopColor: "#0E88D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E88D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 388.462,
    x2: 388.462,
    y1: 4.938,
    y2: 1062.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#168CD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1C87CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#154B8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 64.448,
    x2: 69.031,
    y1: -83.468,
    y2: 27.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97D6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#55C1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C1EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 28.387,
    x2: 49.096,
    y1: 4.043,
    y2: -113.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ACCEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB7ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 291.684,
    x2: 291.684,
    y1: 62.128,
    y2: 1096.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DA7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ABE7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h27v25.734H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotNet);
export default __webpack_public_path__ + "static/media/DotNET.581b88ec72886306b6c14f1464096d41.svg";
export { ForwardRef as ReactComponent };